import { ICanceller, CancelToken } from 'app/utils/cancelToken';
import { ITask, ITaskQueue } from 'app/utils/queues/constants';

export default class TaskQueue implements ITaskQueue {
  private last = Promise.resolve(null);
  private canceller: ICanceller = CancelToken.create();

  public push<T>(task: ITask<T>): Promise<T> {
    const { cancelToken } = this.canceller;

    const update = this.last.then(() => task(cancelToken));

    // Calling `.then()` with two arguments on `update` will prevent it from
    // triggering an unhandled promise rejection event.
    this.last = update.then(() => null, () => null);

    // If this promise rejects, it will trigger an unhandled promise rejection
    // unless the code that calls `.push()` catches the error.
    const preserveUnhandledRejection: Promise<T> = new Promise((resolve, reject) => {
      update.then(resolve, reject);
    });

    return preserveUnhandledRejection;
  }

  public abort() {
    const { cancelToken, cancel } = this.canceller;
    cancel();
    this.canceller = CancelToken.create();
    return cancelToken;
  }
}
